/* eslint-disable react-hooks/exhaustive-deps */
import { FormEvent, useState } from "react";
import classNames from "clsx";

import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import { motion } from "framer-motion";

import { KTSVG } from "@/../_metronic/helpers";
import { useWindowDimensions } from "@/hooks/useWindowDimensions";
import { BREAKPOINTS } from "@/styles/constants/breakpoints";

import { PatientList } from "./PatientList";

import "./styles.scss";

type Props = {
	admissionQueueIsOpen: boolean;
	setAdmissionQueueIsOpen: (value: boolean) => void;
	setQueueAdmissionData: (value: QueueAdmissionData) => void;
	setPatientAdmissionModalShow: (value: boolean) => void;
	isPatientAdmitted: boolean;
};

export function AdmissionQueue({
	admissionQueueIsOpen,
	setAdmissionQueueIsOpen,
	setQueueAdmissionData,
	setPatientAdmissionModalShow,
	isPatientAdmitted,
}: Props) {
	const [search, setSearch] = useState("");

	const { width } = useWindowDimensions();

	const CONTAINER_HEIGHT = admissionQueueIsOpen ? "57vh" : "67vh";
	const CONTAINER_WIDTH = admissionQueueIsOpen ? "37%" : "6%";
	const IS_HIDDEN = width <= BREAKPOINTS.DESKTOP_MEDIUM;

	const CONTAINER_CLASS_NAME = classNames(
		"card h-77vh ms-6 py-6",
		admissionQueueIsOpen && "px-3"
	);
	const BUTTON_CONTAINER_CLASS_NAME = classNames(
		admissionQueueIsOpen ? "position-absolute" : "d-flex justify-content-center px-6"
	);
	const PATIENT_LIST_CONTAINER_CLASS_NAME = admissionQueueIsOpen ? "mt-10 px-3" : "";
	const PATIENT_LIST_CLASS_NAME = admissionQueueIsOpen ? "" : "d-flex justify-content-center";

	const handlePatientAdmissionModalShow = () => setPatientAdmissionModalShow(true);

	function handleAdmissionQueueCollapse(event: FormEvent<HTMLButtonElement>) {
		const icon = event.currentTarget;
		if (icon) {
			icon.classList.toggle("rotate");
		}
		setAdmissionQueueIsOpen(!admissionQueueIsOpen);
	}

	function handlePatientAdmit(surgicalAttendance: SurgicalAttendance) {
		handlePatientAdmissionModalShow();
		setQueueAdmissionData({
			attendanceId: surgicalAttendance.attendanceId,
			surgicalAttendanceId: surgicalAttendance.id,
			patientName: surgicalAttendance.patient.name,
			expertiseId: surgicalAttendance.expertiseId,
			expertiseName: surgicalAttendance.expertise.name,
			isQueueAdmission: true,
		});
	}

	return (
		<motion.div
			hidden={IS_HIDDEN}
			id="admission-queue-container"
			animate={{ width: CONTAINER_WIDTH }}
			className={CONTAINER_CLASS_NAME}
		>
			<div className="mb-6">
				<div className={BUTTON_CONTAINER_CLASS_NAME}>
					<Button
						variant="default"
						style={{ transition: "0.4s" }}
						className="arrow-collapse btn-active-color-primary p-0"
						id="admission-queue-button"
						onClick={handleAdmissionQueueCollapse}
					>
						<KTSVG
							path="/media/icons/duotune/arrows/arr024.svg"
							className="svg-icon-1 me-n1 minimize-default"
						/>
					</Button>
				</div>

				{admissionQueueIsOpen && (
					<div className="d-flex justify-content-center">
						<Card.Title className="fs-3 m-0">Fila de Admissão em Leito</Card.Title>
					</div>
				)}

				<div className={PATIENT_LIST_CONTAINER_CLASS_NAME}>
					<PatientList
						search={search}
						setSearch={setSearch}
						onPatientAdmit={handlePatientAdmit}
						height={CONTAINER_HEIGHT}
						showSearch={admissionQueueIsOpen}
						searchPlaceholder="Pesquisar paciente"
						className={PATIENT_LIST_CLASS_NAME}
						isPatientAdmitted={isPatientAdmitted}
					/>
				</div>
			</div>
		</motion.div>
	);
}
